import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { StationsAutocomplete } from '@app/components/stations/StationsAutocomplete';
import { useOwnedStations } from '@app/core/stations/hooks/useOwnedStations';
import { Station } from '@app/core/types/stations';
import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { connectionsManageMessages as messages } from '../connections-manage-messages';

type Props = {
  /** Selected station IDs for this connection (draft until settings are saved). */
  stationIds: string[];
  onChange: (stationIds: string[]) => void;
};

/**
 * Multi-select of owned stations to assign to the connection.
 * Persisted with the settings form via PATCH `/connections/:id` (`stationIds`).
 */
export function ConnectionStationsSettingsSection({ stationIds, onChange }: Props) {
  const { $t } = useIntl();
  const ownedStations = useOwnedStations();

  const selectedStations = useMemo(() => {
    const byId = new Map(ownedStations.map((station) => [station.id, station]));
    return stationIds
      .map((id) => byId.get(id))
      .filter((station): station is Station => station != null);
  }, [ownedStations, stationIds]);

  return (
    <ContentCluster title={$t(messages.stationsPublishingWithAccount)} divider={false}>
      <Grid container>
        <Grid item md={12} lg={8} xl={6}>
          <StationsAutocomplete
            multiple
            size="medium"
            stations={ownedStations}
            value={selectedStations}
            onChange={(stations) => onChange(stations.map((station) => station.id))}
            label={false}
            placeholder={$t(messages.selectStationsPlaceholder)}
            helperText={$t(messages.selectStationsHelper)}
          />
        </Grid>
      </Grid>
    </ContentCluster>
  );
}
